import { User, UserConnectionInput } from '@/models/gen/graphql';

import { SearchUsersDocument } from '@/api/queries';
import graphApi from '@/api';
import { queryInput } from '@/utils';

const [, runRefetchSearchUser] = graphApi(SearchUsersDocument);

export const refetchSearchUser = async (...ids: User['id'][]): Promise<User[]> => {
  const input: UserConnectionInput = {
    first: ids.length,
    after: null,
    query: [
      {
        id: queryInput(ids),
      },
    ],
  };

  const res = await runRefetchSearchUser({ input });

  return res?.searchUsers?.userConnection.edges?.map((edge) => edge?.node).filter((node): node is User => !!node) || [];
};

export const isUsernameTaken = async (username: string): Promise<boolean> => {
  try {
    const res = await runRefetchSearchUser({
      input: { first: 1, after: null, query: [{ username: queryInput(username) }] },
    });
    return (res?.searchUsers?.userConnection.edges?.length || 0) > 0;
  } catch (err) {
    console.error('Error checking username availability:', err);
    return false;
  }
};
